import * as React from "react";
import { Paper, Typography, TextField, Button, InputAdornment } from "../../components/mui";
import { AccountCircleRoundedIcon, LockRoundedIcon } from "../../components/icons";

import "../../styles/pages/login.css";
import logoStaystrack from "../../images/logo-staystrack.svg";

/**
 * Login Page Component
 * UI/Layout only - Backend developer will add:
 * - Form state management (username, password)
 * - Input validation
 * - API call to authentication endpoint
 * - Error handling (invalid credentials)
 * - Loading state during login
 * - Remember me functionality
 * - Forgot password flow
 * - Session management
 */
export default function Login({ onLogin }) {
  return (
    <div className="login-root">
      <Paper elevation={12} className="login-card">
        <div className="login-overlay" aria-hidden />

        <div className="login-brand">
          <div className="login-badge">
            <img
              src={logoStaystrack}
              alt="StaysTrack logo"
              className="login-badge-image"
            />
          </div>
          <div>
            <Typography variant="h4" className="login-title">
              StaysTrack
            </Typography>
            <Typography variant="subtitle2" className="login-subtitle">
              Condo Management System
            </Typography>
          </div>
        </div>

        <Typography variant="body1" className="login-text">
          Sign in to keep residents, amenities, and operations on track.
        </Typography>

        <div className="login-input-group login-input-group--first">
          <Typography variant="caption" className="login-label">
            Username
          </Typography>
          <TextField
            variant="outlined"
            fullWidth
            margin="none"
            className="login-input"
            placeholder="Enter your username"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircleRoundedIcon className="login-icon" />
                </InputAdornment>
              ),
            }}
          />
        </div>

        <div className="login-input-group">
          <Typography variant="caption" className="login-label">
            Password
          </Typography>
          <TextField
            type="password"
            variant="outlined"
            fullWidth
            margin="none"
            className="login-input"
            placeholder="Enter your password"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockRoundedIcon className="login-icon" />
                </InputAdornment>
              ),
            }}
          />
        </div>

        <Button
          variant="contained"
          fullWidth
          size="large"
          className="login-button"
          onClick={onLogin}
        >
          Login
        </Button>

        <div className="login-footer">
          <Typography variant="caption" className="login-muted">
            Need access? Contact the property admin team.
          </Typography>
        </div>
      </Paper>
    </div>
  );
}
